<template>
    <el-form ref="form" :model="dioForm" :rules="rules" label-width="150px">
        <el-form-item :label="$t('public.table_scope')" prop="sceneId" v-show="isSysAdmin">
            <span>{{ dioForm.scopeText }}</span>
        </el-form-item>
        <el-form-item :label="$t('public.table_arch')" prop="structureText">
            <el-select style="width:250px" v-model="dioForm.structureText" popper-class="Architecture">
                <el-option :value="dioForm.structureText">
                    <div class="treeClass">
                        <trees @changeNode="nodeClick" :treedata="dataTree" ref="tree" node-key="id" />
                    </div>
                </el-option>
            </el-select>
        </el-form-item>

        <el-form-item :label="$t('public.table_carrier_name')" prop="keycode">
            <el-input v-model.trim="dioForm.keycode" style="width: 250px"></el-input>
        </el-form-item>
        <el-form-item :label="$t('business.carrier_status')" prop="status">
            <el-select v-model="dioForm.status" style="width: 250px">
                <el-option v-for="item in getCarrierStatus" :key="item.code"
                 :label="getLanguage() === 'zh_CN'?item.name:item.content" :value="item.code"> </el-option>
            </el-select>
        </el-form-item>

        <el-form-item :label="$t('public.type')" prop="carrierTypeName">
            <span>{{ dioForm.carrierTypeName }}</span>
        </el-form-item>
        <el-form-item :label="$t('integration.sampling_strategy')" prop="sampleStrategy">
            <el-select v-model="dioForm.sampleStrategy" style="width: 250px">
                <el-option v-for="(item, key) in sampleSrategy" :key="key" :label="$t(item.title)" :value="parseInt(key)"> </el-option>
            </el-select>
        </el-form-item>

        <el-form-item :label="$t('public.mode')" prop="mode">
            <el-select v-model="dioForm.mode" style="width: 250px">
                <el-option v-for="(item, key) in carrierMode" :key="key"
                 :label="$t('asset.mode.' + item.content)" :value="parseInt(key)"> </el-option>
            </el-select>
        </el-form-item>
        <el-form-item :label="$t('business.traceable')" prop="isTrace">
            <el-checkbox v-model="dioForm.isTrace" :true-label="1" :false-label="0"></el-checkbox>
        </el-form-item>
        <!--<el-form-item :label="$t('device.alarm_on')" prop="alarmSwitch">-->
        <!--    &lt;!&ndash; <el-checkbox v-model="dioForm.alarmSwitch" :true-label="1" :false-label="0"></el-checkbox> &ndash;&gt;-->
        <!--    <div style="width:400px">-->
        <!--        <el-tag effect="dark" v-for="trigger in detailObj.alarmTriggerList" @click="$emit('triggerDetail', trigger.id)" :key="trigger.id" class="cursor-pointer icon-margin">{{-->
        <!--            trigger.name-->
        <!--        }}</el-tag>-->
        <!--        <i class="el-icon-setting" style="margin-left:-2px" :title="$t('integration.alarm_settings')" @click="handleToAlarmSetFn"></i>-->
        <!--    </div>-->
        <!--</el-form-item>-->
        <el-form-item :label="$t('business.tag')" prop="tag">
            <el-input v-model.trim="dioForm.tag" style="width: 250px"></el-input>
        </el-form-item>
        <el-form-item :label="$t('public.table_desc')" prop="description">
            <el-input
                v-model.trim="dioForm.description"
                style="width: 250px;margin-left: -5px;"
                type="textarea"
                maxlength="250"
                :autosize="{ minRows: 2, maxRows: 4 }"
                show-word-limit
                :placeholder="$t('public.please_enter')"
            />
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="handleSave">{{ $t('public.save') }}</el-button>
            <el-button type="primary" @click="$emit('back')" style="margin-left: 10px !important;">{{ $t('integration.return') }}</el-button>
        </el-form-item>
    </el-form>
</template>

<script>

import { carrierEdit } from '@/api/modules/carrier.js'
import { sampleSrategy } from '@/utils/convert'
import { getLanguage } from '@/lang';

export default {
  props: ['getCarrierStatus', 'detailObj'],
  watch: {
    getCarrierType (newVal) {
      this.dioForm.carrierTypeName = this.$t('carrier.' + newVal.code)
    },
    detailObj (newVal) {
      if (newVal) {
        const { sceneId, fullPath, structureName, structureId, keycode, typeName, status, isTrace, tag, alarmSwitch, id, description, alarmTriggerList, sampleStrategy, mode } = newVal
        this.dioForm = {
          sceneId,
          scopeText: fullPath && fullPath.split('/')[0],
          structureText: structureName,
          structureId,
          keycode,
          carrierTypeName:  this.$t('carrier.' + newVal.typeId),
          status: String(status),
          isTrace,
          tag,
          alarmSwitch,
          description,
          id,
          alarmTriggerCarrierList: alarmTriggerList,
          sampleStrategy,
          mode
        }
      }
    }
  },
  computed: {
    sampleSrategy: () => sampleSrategy,
    isShowDialog: {
      get: function () {
        return this.isShow
      },
      set: function (val) {
        this.$emit('update:isShow', val) // 可以优化成model  或者minx
      }
    },
    /** 用于表示当前登录用户属于什么类型的角色 */
    isSysAdmin () {
      const currentUser = this.$store.getters.userInfo.scope
      return currentUser.sysScope && currentUser.sysAdmin
    },
    carrierMode () {
      return this.$store.state.carrierMode
    },
    rules () {
      const checkDH = (rules, value, cb) => {
        const reg = /^(?!.*-)[^，]*$/
        if (!reg.test(value)) cb($t('integration.chinese_comma_and_center_line_cannot_be_entered'))
        cb()
      }
      return {
        structureText: [
          {
            required: true,
            message: this.$t('messageTitle.ContentNotEmpty'),
            trigger: 'change'
          }
        ],
        status: [
          {
            required: true,
            message: $t('integration.monitoring_point_status_cannot_be_empty'),
            trigger: 'change'
          }
        ],
        keycode: [
          {
            required: true,
            message: $t('integration.monitoring_point_name_cannot_be_empty'),
            trigger: 'blur'
          },
          {
            max: 50,
            message: $t('integration.the_length_of_monitoring_point_is_within_50'),
            trigger: 'blur'
          },
          {
            trigger: ['blur', 'change'],
            validator: checkDH
          }
        ],
        tag: [
          {
            max: 50,
            message: $t('integration.the_length_of_monitoring_point_is_within_50'),
            trigger: 'blur',
            required: false
          }
        ],
        description: [
          {
            max: 250,
            message: $t('integration.the_length_of_monitoring_point_is_within_250'),
            trigger: 'blur',
            required: false
          }
        ],
        mode: [
          {
            required: true,
            message: $t('必须选择模式'),
            trigger: 'change'
          }
        ]
      }
    },
    dataTree () {
      return this.$store.getters.SchemaTree.filter(item => {
        return item.sceneCode !== 'all_node'
      })
    }
  },
  data () {
    return {
      dioForm: {
        sceneId: null,
        scopeText: null,
        structureText: null,
        structureId: null,
        keycode: null,
        carrierTypeName: null,
        status: null,
        isTrace: 1,
        tag: null,
        alarmSwitch: 1,
        mode: null
      },
      getCarrierType: {},
      getLanguage
    }
  },
  created () {
    this.getCarrierType = JSON.parse(sessionStorage.getItem('getCarrierType'))
  },
  methods: {
    /** 报警设置 */
    handleToAlarmSetFn () {
      // 直接抛出一个方法
      this.$emit('editAlarm')
    },
    clearValidate () {
      if (this.$refs.form) {
        this.$refs.form.resetFields()
      }
    },
    async justify () {
      try {
        return await this.$refs.form.validate()
      } catch (error) {
        return false
      }
    },
    async handleSave () {
      const flag = await this.justify()
      if (!flag) return

      const query = {
        ...this.dioForm
      }

      // 当有触发器时打开报警开关， 没有触发器时关闭
      if (query.alarmTriggerCarrierList instanceof Array) {
        query.alarmTriggerCarrierList = this.detailObj.alarmTriggerList.map(item => {
          return { alarmTriggerId: item.alarmTriggerId || item.id }
        })
      } else {
        query.alarmTriggerCarrierList = []
      }

      if (query.alarmTriggerCarrierList.length) {
        query.alarmSwitch = 1
      } else query.alarmSwitch = 0

      delete query.scopeText
      delete query.structureText
      delete query.carrierTypeName

      // 换成Typeid请求 否则会更改掉类型
      carrierEdit(query, this.detailObj.typeId).then(async ({ state }) => {
        await this.$resultHandle(state)
        this.isShowDialog = false
        this.$parent.$parent.getDetailInit()
        // this.$parent.isShowEdit = true;
        this.$emit('back')
        if (window.opener.getList) {
          window.opener.getList()
        }
      })
    },
    nodeClick ({ label }) {
      if (label.level === 0) return this.$message.warning(this.$t('messageTitle.SelectTheNodeUnderTheRange'))
      this.dioForm.sceneId = label.scopeId
      this.dioForm.structureId = label.sceneId
      this.structureText = this.dataTree.forEach(item => {
        if (item.scopeId === label.scopeId) {
          this.dioForm.structureText = item.label + '-' + label.label
          this.dioForm.scopeText = item.label
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.treeClass {
    width: 100%;
    height: 100%;
    overflow: auto;

    .el-tree {
        height: 100%;
    }
}

i {
    font-size: 18px;
    font-weight: bold;
    // margin-left: 10px;
    cursor: pointer;

    color: #344962;
}

::v-deep .el-textarea__inner {
    border-radius: 2px;
    margin-left: 5px;
    // margin-left: 5px;
}
</style>
